// LOGIN
export const GET_AUTHENTICATION_DETAILS = "GET_AUTHENTICATION_DETAILS";
export const SET_AUTHENTICATION_DETAILS = "SET_AUTHENTICATION_DETAILS";
export const SET_AUTHENTICATION_DETAILS_LOADING =
  "SET_AUTHENTICATION_DETAILS_LOADING";
export const OKTA_LOGIN_PAGE = import.meta.env.VITE_CC_OKTA_LOGIN_PAGE;
